import styled from 'styled-components';
import COLORS from '../../../../common/styles/color-pallete';
import DEVICES from '../../../../common/styles/devices';
import { FONT_FAMILY } from '../../../../common/styles/fontStyles';

type ParentContainerProps = {
  padding: Array<number>;
  headingDescWidth?: number;
  isNiumForexUser?: boolean;
  marginTop?: number;
  headerAlignment?: string;
  isSgKycRfi?: boolean;
  isSgOnboardingflow?: boolean;
};

const formatPadding = (padding: Array<number>) => {
  if (padding.length === 2) {
    return `${padding[0]}px ${padding[1]}px`;
  } else if (padding.length === 4) {
    return `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`;
  } else {
    return `0`;
  }
};

export const VeriffContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2em 2em 0 2em;
  .veriff-root {
    width: 400px;
  }
  .veriff-container {
    visibility: hidden;
  }
`;

export const ParentContainer = styled.div<ParentContainerProps>`
  padding: ${({ isSgOnboardingflow, padding }) =>
    isSgOnboardingflow ? '0 10%' : formatPadding(padding)};
  width: ${({ isSgKycRfi }) => (isSgKycRfi ? '100% !important' : 'unset')};
  display: ${({ isSgOnboardingflow }) => (isSgOnboardingflow ? 'block' : 'flex')};
  justify-content: flex-start;
  align-items: ${({ isSgKycRfi }) => (isSgKycRfi ? 'left' : 'center')};
  flex-direction: column;
  input[type='file'] {
    opacity: 0 !important;
    position: absolute !important;
  }
  input {
    &:not(:placeholder-shown):not(:focus) {
      border-color: ${COLORS.borderGrey};
    }
    ::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
    ::-moz-placeholder {
      /* Firefox 19+ */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
    :-ms-input-placeholder {
      /* IE 10+ */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
    :-moz-placeholder {
      /* Firefox 18- */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
  }
  .search-icon {
    opacity: 1 !important;
    width: 22px !important;
    height: 22px !important;
  }
  .navigation-container {
    display: ${({ isSgOnboardingflow }) => (isSgOnboardingflow ? 'inline' : 'grid')};
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    align-items: center;
    justify-content: center;
    z-index: 2;
    .header-text-container {
      margin: 0 !important;
    }
    .back-button {
      grid-column: 1;
      cursor: pointer;
    }
    .close-button {
      grid-column: 3;
      cursor: pointer;
    }
    * {
      justify-self: center;
    }
    @media ${DEVICES.mobileXL} {
      margin-top: 48px;

      .close-button {
        justify-self: right;
      }
    }
  }
  .header-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: ${(props) =>
      props.isNiumForexUser ? 0 : props.marginTop ? `${props.marginTop}px` : '-35px'};
    img {
      margin: 0;
    }
    .progress {
      margin: 6px 0 0 0 !important;
      width: 136px;
      height: 4px !important;
      .bar {
        width: 51px;
        height: 4px !important;
        background: ${COLORS.dividerBlue} !important;
      }
    }
    .step-number {
      color: ${COLORS.textLightGrey};
      margin-top: 8px;
      font-size: 12px;
      font-weight: 400;
    }
  }
  .header-text-container {
    width: ${({ isSgOnboardingflow }) => (isSgOnboardingflow ? '0' : '450px')};
    margin-top: 16px;
    display: ${({ isSgOnboardingflow }) => (isSgOnboardingflow ? 'inline' : 'flex')};
    flex-direction: column;
    justify-content: flex-start;
    align-items: ${({ headerAlignment }) =>
      headerAlignment ? headerAlignment : 'center'} !important;
    .heading-text {
      color: ${COLORS.black};
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 28px;
      line-height: 38px;
    }
    .heading-subtext {
      color: ${COLORS.black};
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 18px;
      line-height: 26px;
      margin-top: 48px;
      display: flex;
    }
    .heading-text-docs {
      color: ${COLORS.black};
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 28px;
      line-height: 38px;
      align-self: flex-start;
    }
    .heading-description {
      display: ${({ isSgOnboardingflow }) => (isSgOnboardingflow ? 'flex' : 'inline')};
      color: ${COLORS.textGrey};
      width: ${({ isSgOnboardingflow, headingDescWidth }) =>
        isSgOnboardingflow ? 'unset' : `${headingDescWidth || 450}px`};
      margin-top: 8px;
      line-height: 22px;
      font-weight: 400;
      font-size: 16px;
      text-align: ${({ isSgOnboardingflow }) => (isSgOnboardingflow ? 'left' : 'center')};
    }
  }
  .information-panel-container {
    width: 450px;
    line-height: 18px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: rgba(72, 250, 255, 0.1);
    color: ${COLORS.black};
    padding: 12px 16px;
    border: 1px solid ${COLORS.dividerBlue};
    gap: 0;
    margin-top: 48px;
    border-radius: 8px;
    .header-container {
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      img {
        margin-right: 12px;
      }
    }
    .process-list-container {
      font-size: 14px;
      margin-left: 12px;
      margin-top: 0;
      .list {
        list-style: disc;
        .list-item {
          margin-left: 40px;
        }
      }
    }
    .poa-note {
      margin-top: 24px;
      margin-left: 24px;
    }

    @media ${DEVICES.mobileXL} {
      width: 100%;
    }
  }
  .default.text {
    color: red;
  }
  .form-container {
    div.default.text {
      color: ${COLORS.disabled} !important;
    }
    margin-top: 58px;
    width: 450px;

    width: ${({ isSgKycRfi }) => (isSgKycRfi ? '100%' : '450px')};
    .input-container {
      width: 450px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .input-error-wrapper {
        width: 134px !important;
      }
      .dropdown {
        margin: 0;
        width: 134px;
      }
      .phone-input {
        input {
          border: 1px solid ${COLORS.disabled} !important;
          border-radius: 3px !important;
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          &:hover,
          &:focus {
            border-radius: 3px !important;
            border: 1px solid ${COLORS.black} !important;
          }
        }
      }
      .phone-input,
      .input-error {
        margin-top: 0;
        margin-left: 24px;
        width: 292px;
        height: 50px;
      }

      div[class^='outlinedDropdownField__BoxContainer'] {
        margin-top: 12px !important;
        margin-bottom: 0 !important;
        div.default.text {
          color: red !important;
        }
      }

      .render-text-field {
        margin: 10px 0 0 0;
        label {
          width: 100%;
          margin-top: -14px;
          background: white;
          margin-left: 35px;
          padding: 0 5px;
        }
        .error-msg {
          margin-left: 24px;
          width: 250px;
        }
      }
    }
    .phone-submit {
      margin-top: 48px;
      cursor: pointer;
      width: 450px;
      background: ${COLORS.brandPrimary};
      text-align: center;
      font-weight: 700;
      font-size: 16px;
      outline: none;
      border: none;
      color: ${COLORS.white};
      height: 50px;
      border-radius: 4px;
    }

    .toggle-address-method {
      color: ${COLORS.brandPrimary};
    }
  }

  @media ${DEVICES.mobileXL} {
    width: 100%;
    margin: 0;
    padding: ${({ padding }) => formatPadding(padding)};
    .form-container {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      width: 400px !important;
      .input-container {
        flex-direction: column !important;
        justify-content: space-between;
        align-items: flex-start;
        .phone-input,
        .input-error {
          margin-top: 15px;
          margin-left: 0 !important;
        }
        .input-error {
          margin-left: 24px;
        }
      }
      .input-container,
      .dropdown,
      .phone-input,
      .input-error,
      .phone-submit {
        width: 400px !important;
      }
      .input-container {
        .render-text-field {
          label {
            margin: 4px 8px !important;
          }
          .error-msg {
            margin: 18px 0 !important;
          }
        }
      }
    }
    .header-text-container {
      width: 400px !important;
      .heading-text {
        font-size: 23px;
      }
      .heading-description {
        width: 350px;
        font-size: 14px;
      }
    }
  }

  @media ${DEVICES.mobileL} {
    .form-container {
      width: 350px !important;

      .input-container,
      .dropdown,
      .phone-input,
      .input-error,
      .phone-submit {
        width: 350px !important;
      }
    }
    .header-text-container {
      width: 350px !important;
    }
  }

  @media ${DEVICES.mobileM} {
    .form-container {
      width: 300px !important;

      .input-container,
      .dropdown,
      .phone-input,
      .input-error,
      .phone-submit {
        width: 300px !important;
      }
    }
    .header-text-container {
      width: 300px !important;
      .heading-text {
        font-size: 23px;
      }
      .heading-description {
        width: 300px;
        font-size: 14px;
      }
    }
  }
  @media ${DEVICES.mobileS} {
    padding-bottom: 15px;
    .form-container {
      width: 250px !important;

      .input-container,
      .dropdown,
      .phone-input,
      .input-error,
      .phone-submit {
        width: 250px !important;
      }
    }
    .header-text-container {
      width: 250px !important;
      .heading-text {
        font-size: 23px;
      }
      .heading-description {
        width: 250px;
        font-size: 14px;
      }
    }
  }
`;

export const ManualAddressToggle = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  margin: 3px 0;
  display: flex;
  justify-content: flex-start;
  width: 450px;
  align-items: center;
  color: ${COLORS.darkBlue};
  line-height: 24px;
  font-size: 16px;
  cursor: pointer;

  @media ${DEVICES.mobileXL} {
    width: 400px;
  }

  @media ${DEVICES.mobileL} {
    width: 350px !important;
  }
  @media ${DEVICES.mobileM} {
    width: 300px !important;
  }
`;

type FormContainerProps = {
  marginTop: number;
  isSgKycRfi?: boolean;
  middleNameCheckboxMarginTop?: number;
};

export const FormContainer = styled.div<FormContainerProps>`
  margin-top: ${(props) => props.marginTop}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  align-items: ${({ isSgKycRfi }) => (isSgKycRfi ? 'left' : 'center')};

  .mailingAddressFields {
    margin-top: 40px;
  }

  .form-container__middle-name-check-container {
    width: 100%;
    margin-top: ${(props) => props.middleNameCheckboxMarginTop || 12}px;
  }

  div.default.text {
    color: ${COLORS.disabled} !important;
  }
  .retrieved-info-container {
    width: 100%;
  }
  .document-info-container {
    width: 100%;
  }

  div[class*='makeStyles-formControl'] {
    width: 100% !important;
    max-width: inherit !important;
  }
  @media ${DEVICES.mobileXL} {
    width: 400px !important;
    .retrieved-info-container {
      width: 400px !important;
    }
    .document-info-container {
      width: 100%;
      margin-left: 10%;
    }
  }

  @media ${DEVICES.mobileL} {
    width: 350px !important;
    .retrieved-info-container {
      width: 350px !important;
    }
    .document-info-container {
      width: 100%;
      margin-left: 10%;
    }
  }
  @media ${DEVICES.mobileM} {
    width: 300px !important;
    .retrieved-info-container {
      width: 300px !important;
    }
    .document-info-container {
      width: 100%;
      margin-left: 15%;
    }
  }
`;
type RowProps = {
  padding: Array<number>;
  shouldHide?: boolean;
  flexDirection?: string;
  isSgKycRfi?: boolean;
};
export const Row = styled.div<RowProps>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: ${({ isSgKycRfi }) => (isSgKycRfi ? 'center' : ' flex-start')};
  flex-direction: ${({ flexDirection }) => (flexDirection ? 'row' : 'column')};
  padding: ${({ padding }) => formatPadding(padding)};
  display: ${({ shouldHide }) => (!shouldHide ? 'flex' : 'none')};
  @media ${DEVICES.mobileS} {
    flex-direction: column;
  }
`;

export const CenteredRow = styled.div<RowProps>`
  display: flex;
  align-items: center;
  padding: ${({ padding }) => formatPadding(padding)};
`;

type ColProps = {
  width: number;
  isHalfColumn?: boolean; //
};
export const Col = styled.div<ColProps>`
  width: ${(props: any) => props.width}px;

  .MuiFormControl-marginNormal {
    margin-left: 0px !important;
  }

  .checkBoxMessage {
    color: ${COLORS.textGrey};
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }
  .nium-forex-file-size-error-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    .replace-text {
      margin-top: 8px;
    }
  }

  div[class*='makeStyles-formControl'] {
    margin: 0 !important;
  }
  div[class*='jss'] {
    margin: 0 !important;
  }
  .MuiInputBase-root {
    width: ${({ isHalfColumn }) => (isHalfColumn ? '100%' : '450px')} !important;
  }
  label.label-color,
  label.MuiFormLabel-root {
    font-size: 16px !important;
    line-height: 17px !important;
  }
  label.Mui-error {
    color: ${COLORS.newerror} !important;
  }
  label.Mui-focused {
    margin-top: -3px !important;
  }
  .MuiFormControl-root {
    height: 50px;
    margin-bottom: 0;
  }
  div.Mui-focused {
    outline: none !important;
    border: none !important;
  }
  margin: 0;
  .div-160 {
    width: 160px !important;
  }
  .consent-text {
    font-size: 12px;
    line-height: 16px;
    color: ${COLORS.textLightGrey};
  }
  .disclaimer-text {
    font-size: 12px;
    line-height: 18px;
    color: ${COLORS.textGrey};
    font-family: ${FONT_FAMILY.hellix.regular};
  }

  .replace-text {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin-top: 8px;
    text-align: center;
    color: ${COLORS.darkBlue};
    cursor: pointer;
    float: right;
  }
  .selected-file-name {
    width: 150px;
    margin-top: 8px;
    color: ${COLORS.textLightGrey};
    float: left;
    font-size: 12px;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    white-space: nowrap;
  }
  .selected-file-type {
    margin-top: 8px;
    color: ${COLORS.textLightGrey};
    float: left;
    font-size: 12px;
    line-height: 22px;
  }

  span.error-msg {
    margin-top: 5px;
    color: ${COLORS.newerror};
    font-size: 12px;
    position: unset;
  }
  .__passport-header {
    font-weight: 700;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .form-text-field,
  .input.form-flow {
    width: 100%;
    .input {
      width: 100%;
    }
    label {
      background-color: ${COLORS.white};
      padding: 0 5px;
      margin: -14px 10px;
    }
    input {
      width: 100%;
      height: 50px;
      border: 1px solid ${COLORS.textDarkGray};
      border-radius: 3px;
      &:focus {
        border: 1px solid ${COLORS.black};
        border-radius: 3px;
      }
      &:hover {
        border: 1px solid ${COLORS.black};
        border-radius: 3px;
      }
    }
  }
  .date-picker-label {
    margin: -8px 10px;
    padding: 0 5px;
    background: ${COLORS.white};
  }
  .react-datepicker-wrapper {
    border: 1px solid ${COLORS.textDarkGray};
    border-radius: 3px;
    .react-datepicker__input-container {
      padding: 15px 10px !important;
      border: none !important;
    }
  }

  #issuingCountry {
    width: 380px !important;
  }

  @media ${DEVICES.mobileXL} {
    width: 400px !important;
    #issuedBy,
    #issuingCountry {
      width: 400px;
    }
    .MuiInputBase-root {
      width: 400px !important;
    }
  }
  @media ${DEVICES.mobileL} {
    width: 350px !important;
    #issuedBy,
    #issuingCountry {
      width: 350px;
    }
    .MuiInputBase-root {
      width: 350px !important;
    }
  }
  @media ${DEVICES.mobileM} {
    width: 300px !important;
    #issuedBy,
    #issuingCountry {
      width: 300px !important;
    }
    .MuiInputBase-root {
      width: 300px !important;
    }
  }
  @media ${DEVICES.mobileS} {
    width: 250px !important;
    #issuedBy,
    #issuingCountry {
      width: 250px !important ;
    }
    .MuiInputBase-root {
      width: 250px !important;
    }
  }
`;

type SubmitButtonProps = {
  margin: Array<number>;
  width?: number;
  disabled?: boolean;
};
export const SubmitButton = styled.button<SubmitButtonProps>`
  margin: ${({ margin }) => formatPadding(margin)};
  width: ${(props) => (props.width ? props.width + 'px' : '100%')};
  background-color: ${(props) =>
    props.disabled ? `${COLORS.disabled}` : `${COLORS.brandPrimary}`};
  height: 46px;
  color: ${(props) => (props.disabled ? `${COLORS.lightGrey}` : `${COLORS.white}`)};
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  border: none;
  outline: none;
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;
export const ScanText = styled.div`
  width: 390px;
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  color: ${COLORS.textGrey};
  margin: 48px 0;
  @media ${DEVICES.mobileXL} {
    width: 100% !important;
  }
`;

export const AddressSearchSwitch = styled.div`
  width: 100%;
  margin-top: 24px;
  font-weight: 700;
  font-size: 16px;
  color: ${COLORS.darkBlue};
  text-align: center;
  cursor: pointer;
  font-family: ${FONT_FAMILY.hellix.bold};
`;
export const AddressSearchContainer = styled.div`
  width: 450px;
  margin-top: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  .payee-details-column {
    display: none;
  }
  #dropdown-suggestion {
    top: 85px !important;
  }
  .suggestion {
    object-fit: contain;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    padding: 10px;
    border: none;
    P {
      color: ${COLORS.black};
      align-self: center;
    }
    img {
      margin: 0 15px;
      align-self: center;
    }
  }

  .suggestion:hover {
    background: rgba(72, 249, 254, 0.4);
  }

  .suggestion:last-child {
    border-bottom: none;
  }
  .test {
    width: 101px;
    height: 50px;
  }

  @media ${DEVICES.mobileXL} {
    width: 400px !important;
    .input-wrapper-left {
      width: 400px !important;
      .search-icon {
        margin: 12px;
        height: 10px;
        width: 10px;
      }
    }
  }

  @media ${DEVICES.mobileL} {
    width: 350px !important;
    .input-wrapper-left {
      width: 350px !important;
      .search-icon {
        margin: 12px;
        height: 10px;
        width: 10px;
      }
    }
  }
  @media ${DEVICES.mobileM} {
    width: 300px !important;
    .input-wrapper-left {
      width: 300px !important;
      .search-icon {
        margin-left: 10px;
        height: 10px;
        width: 10px;
      }
    }
  }
`;

export const VerificationContainer = styled.div`
  width: 450px;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const VerificationMethod = styled.div`
  cursor: pointer;
  margin: 8px 16px;
  width: 100%;
  height: 78px;
  border: 1px solid ${COLORS.borderGrey};
  padding: 0 22px 0 12px;
  border-radius: 2px;
  background-color: ${COLORS.white};
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 2fr 15fr 2fr;
  justify-content: center;
  align-items: center;
  text-align: center;
  .main-text {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 14px;
    font-weight: 700;
  }

  @media ${DEVICES.mobileXL} {
    width: 400px;
    grid-template-columns: 1fr 10fr 1fr;
  }
  @media ${DEVICES.mobileL} {
    width: 350px;
    grid-template-columns: 1fr 10fr 1fr;
  }
  @media ${DEVICES.mobileM} {
    width: 280px !important;
    grid-template-columns: 1fr 10fr 1fr;
  }
  @media ${DEVICES.mobileS} {
    width: 280px !important;
    display: grid;
    grid-template-columns: 1fr 10fr 1fr;
    padding: 0;
    .image-container {
      padding: 0;
      margin-left: 10px;
      height: 16px;
      img {
        justify-self: center;
        height: 16px;
        height: 16px;
      }
    }
    .mid-section-container {
      padding: 0 4px;
      .main-text {
        font-size: 10px;
        line-height: 0;
        font-weight: 700;
      }
    }
    .verification-method-right-icon {
      display: block !important;
      float: right;
      padding: 0 8px;
    }
  }

  .image-container {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-right: 1px solid ${COLORS.borderGrey};
    padding: 0 6px 0 0;
    img {
      align-self: center;
      height: 24px;
      width: 24px;
    }
  }
  .mid-section-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0 12px;
    .main-text {
      font-size: 14px;
      font-weight: 700;
      line-height: 26px;
    }
    .sub-text {
      text-align: start;
      line-height: 14px;
      font-size: 12px;
      font-weight: 400;
      color: ${COLORS.textGrey};
      text-align: left;
    }
  }
  .verification-method-right-icon {
    text-align: center;
    display: flex;
    justify-content: flex-end;
  }
`;

export const UploadButtonContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 160px;
  min-height: 120px;
  border: 1px solid ${COLORS.borderGrey};
  margin-top: 8px;
  border-radius: 4px;

  .uploadButtons {
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .cta-text-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .image-file {
    width: 150px;
    height: 100px;
  }

  span {
    margin-top: 6px;
    color: ${COLORS.darkBlue};
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
  }
  @media ${DEVICES.mobileM} {
    width: 130px;
    .image-file {
      width: 120px;
      height: 90px;
    }
  }
  @media ${DEVICES.mobileS} {
    width: 115px;
    .image-file {
      width: 100px;
      height: 80px;
    }
  }
`;

type MarginRightProps = {
  marginRight: number;
};
export const MarginRight = styled.div<MarginRightProps>`
  margin-right: ${(props) => props.marginRight}px;
  height: 130px;
`;

export const UploadFileContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 150px;
  justify-content: flex-start;
  span.error-msg {
    margin-top: 8px;
    font-size: 12px;
    left: auto !important;
    top: auto !important;
    color: ${COLORS.newerror};
  }
  span.remove-msg {
    font-size: 12px;
    color: ${COLORS.newerror};
    cursor: pointer;
    text-decoration: underline;
  }
  @media ${DEVICES.mobileS} {
    width: 300px;
  }

  .replace-text-container {
    margin-top: 8px;
    .left-text {
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
      color: ${COLORS.textLightGrey};
    }
    .replace-text-right {
      float: right;
      font-size: 14px;
      line-height: 22px;
      font-weight: 700;
      color: ${COLORS.darkBlue};
      cursor: pointer;
    }
  }
`;

export const OuterUploadAndCaptureContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const UploadAndCaptureContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 150px;
  justify-content: flex-start;
`;

export const OrMessage = styled.div`
  font-size: 14px;
  line-height: 18px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textGrey};
  margin-right: 12px;
`;

type LicenseFileUploadTextContainerProps = {
  fontWeight?: number;
  textColor?: any;
  cursor?: boolean;
  headerMarginTop?: number;
};

export const LicenseFileUploadTextContainer = styled.div<LicenseFileUploadTextContainerProps>`
  margin-bottom: 6px;
  width: 100%;
  display: flex;
  flex-direction: column;
  .__heading {
    font-size: 14px;
    font-weight: ${({ fontWeight }) => fontWeight! | 700};
    margin-top: ${(props) => props.headerMarginTop! | 0}px;
    margin-bottom: 5px;
    color: ${({ textColor }) => textColor};
    cursor: ${({ cursor }) => (cursor ? 'pointer' : 'inherit')};
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .__description {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
    color: ${COLORS.textLightGrey};
  }
`;

type OneTimePasswordContainerProps = {
  height?: number;
  width?: number;
  buttonWidth?: number;
  buttonTopMargin?: number;
  containerMarginTop?: number;
};
export const ModalContainer = styled.div<OneTimePasswordContainerProps>`
  background: ${COLORS.white};
  width: ${({ width }) => width}px;
  border-radius: 4px;
  min-height: ${({ height }) => height}px;
  gap: 32px;
  padding: 16px 16px 32px 16px;

  .modal-submit-button {
    width: 100%;
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal-body-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-top: ${(props) => props.containerMarginTop}px;
    .heading {
      font-family: ${FONT_FAMILY.hellix.bold};
      font-weight: 700;
      font-size: 28px;
      line-height: 38px;
      margin-bottom: 24px;
      color: ${COLORS.black};
    }
    .otp-description {
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      color: ${COLORS.textGrey};
    }
    .information-container {
      display: flex;
      flex-direction: column;
      margin-top: 24px;
      .information-row {
        text-align: center;
        line-height: 38px;
        font-size: 24px;
        font-weight: 400;
        color: ${COLORS.textLightGrey};
      }
    }
    .sample-passport {
      margin-top: 16px;
      height: 260px;
      width: 213px;
    }
    .sample-passport-desc {
      margin-top: 16px;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      text-align: center;
      color: ${COLORS.textGrey};
    }
    .modal-submit-button-container {
      width: 100%;
      margin-top: 16px;
    }
    .header-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 0;
      align-items: center;
      .__heading {
        font-weight: 700;
        font-size: 14px;
        line-height: 26px;
        text-align: center;
        font-family: ${FONT_FAMILY.hellix.bold};
      }
      .__heading-desc {
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
      }
      .__address-heading {
        font-weight: 700;
        font-size: 18px;
        line-height: 26px;
        text-align: center;
      }
      .__address-heading-desc {
        margin-top: 24px;
        font-weight: 400;
        font-size: 16px;
        line-height: 17px;
        text-align: center;
      }
      .__unable-to-retrieve-info {
        font-family: ${FONT_FAMILY.hellix.bold};
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 26px;
        text-align: center;
        color: ${COLORS.materialUiTextFieldColor};
        margin: 10% 11% 2% 11%;
      }
      .__enter-details-manually {
        font-family: ${FONT_FAMILY.hellix.regular};
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        margin: 5% !important;
        color: ${COLORS.textGrey};
      }
    }
    .full-address-container {
      margin-top: 24px;
      margin-bottom: 32px;
      width: 292px;
      height: 52px;
      font-size: 14px;
      font-weight: 700;
      line-height: 26px;
      letter-spacing: 0px;
      text-align: center;
    }
    .different-address-container {
      margin-top: 24px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 700;
      line-height: 26px;
      letter-spacing: 0px;
      text-align: center;
      color: ${COLORS.darkBlue};
    }
    .submit-button {
      margin-top: ${(props) => props.buttonTopMargin}px;
      border: none;
      outline: none;
      border-radius: 4px;
      background-color: ${COLORS.brandPrimary};
      color: ${COLORS.white};
      font-family: ${FONT_FAMILY.hellix.regular};
      font-weight: 700;
      width: ${(props) => props.buttonWidth}px;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      height: 46px;
      cursor: pointer;
      padding: inherit;
    }
    .submit-button-disabled {
      margin-top: ${(props) => props.buttonTopMargin}px;
      border: none;
      outline: none;
      border-radius: 4px;
      background-color: ${COLORS.disabled};
      color: ${COLORS.white};
      font-weight: 700;
      width: ${(props) => props.buttonWidth}px;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      height: 46px;
      cursor: pointer;
    }

    .timer-container {
      margin-top: 30px;
    }
    .resend-code-container {
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text {
        text-align: center;
        color: ${COLORS.textGrey};
        font-size: 16px;
        line-height: 22px;
      }
      .resend-button {
        cursor: pointer;
        color: ${COLORS.darkBlue};
        font-weight: 700;
        font-size: 16px;
        text-align: center;
        line-height: 26px;
      }
    }
  }

  @media ${DEVICES.mobileL} {
    .submit-button,
    .submit-button-disabled {
      width: 100% !important;
    }
  }
`;

export const CloseModalIcon = styled.img`
  display: initial;
  width: 16px;
  align-self: end;
  justify-self: end;
  float: right;
  margin: 22px 22px 0 0;
  cursor: pointer;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 24px;

  .input-txt:last-child {
    margin-right: 0px;
  }
  .pin-input {
    grid-template-rows: 1fr;
    grid-template-columns: repeat(6, 1fr);
    .fragment {
      font-family: ${FONT_FAMILY.hellix.regular};
      width: 30px;
      height: 40px;
      border-radius: 4px;
      font-size: 16px;
      line-height: 28px;
      text-align: center;
      letter-spacing: 0.17px;
      color: ${COLORS.textGrey};
      padding-top: 5px;
      &:focus {
        border: 1px solid ${COLORS.brandPrimary};
        caret-color: ${COLORS.brandPrimary};
      }
    }
  }
  @media screen and (max-width: 540px) {
    padding-top: 30px;
  }
`;

export const ManualDetailsOCRToggle = styled.span`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-top: 24px;
  text-align: center;
  color: ${COLORS.darkBlue};
  cursor: pointer;
`;

export const LoaderContainer = styled.div`
  background-color: ${COLORS.white};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100vw;
  height: 100vh;
  .loader-image {
    width: 150px;
    height: 150px;
    margin-left: 40vw;
    margin-top: 24vh;
  }
`;

export const TextBold = styled.p`
  height: 26px;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: ${COLORS.materialUiTextFieldColor};
`;

export const TextNormal = styled.p`
  height: 26px;
  margin-left: 2%;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: ${COLORS.textGrey}; ;
`;

export const LabelContainer = styled.div`
  display: flex;
  margin: 2%;
`;

export const SectionHeader = styled.p`
  height: 26px;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 26px;
  color: ${COLORS.disabled};

  flex: none;
  order: 0;
  flex-grow: 0;
`;

export const HorizontalLine = styled.div`
  width: 450px;
  height: 0px;
  border: 1px solid ${COLORS.lightGrey};
  flex: none;
  order: 1;
  flex-grow: 0;
`;

export const ClickableLabel = styled.p`
  margin-left: 2%;
  height: 26px;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: ${COLORS.darkBlue};
  flex-grow: 0;
  cursor: pointer;
`;

export const ModalContent = styled.div<OneTimePasswordContainerProps>`
  width: ${({ width }) => width || 450}px;
  border-radius: 4px;
  min-height: ${({ height }) => height}px;
  gap: 32px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  background: white;
  font-family: ${FONT_FAMILY.hellix.regular};
  border-radius: 5px;
  padding: 16px 32px;
  .closeBtn {
    position: absolute;
    top: 22px;
    right: 22px;
    @media ${DEVICES.mobileXL} {
      top: 10px;
      right: 22px;
    }
    @media ${DEVICES.mobileL} {
      top: 5px;
      right: 22px;
    }
  }
  .headingText {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin: 10px;
    height: 50px;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 18px;
    line-height: 24px;
  }
  .element-container {
    width: 100%;
  }
  @media ${DEVICES.mobileXL} {
    width: 325px;
    height: 400px;
  }
  @media ${DEVICES.mobileS} {
    width: 300px;
    height: 400px;
  }
`;

export const P1 = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: ${COLORS.textGrey};
  flex: none;
  order: 1;
  flex-grow: 0;
`;
export const PBold = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  color: ${COLORS.black};
  flex: none;
  order: 0;
  flex-grow: 0;
`;

export const RequiredInfoImage = styled.img`
  width: 21px;
  height: 21px;
  float: right;
  margin-left: 21px;
`;

export const MobileVerificationInputWrapper = styled.div`
  display: flex;
  width: 456px;
  font-size: 14px;
  .input-error-wrapper {
    flex: 30%;
    margin-right: 16px;
  }
  #phone_container {
    flex: 70%;
  }
  .MuiFormLabel-root.Mui-focused {
    font-size: 18px !important;
    margin-top: -3px !important;
  }
  .MuiInputLabel-outlined {
    font-size: 16px !important;
    margin-top: -6px !important;
  }

  @media ${DEVICES.mobileXL} {
    flex-direction: column;
    width: 100%;
    .input-error-wrapper {
      margin-right: unset;
      margin-bottom: 16px;
    }

    .MuiFormControl-root {
      max-width: 100% !important;
      margin: 0 !important;
    }
  }
`;

export const NormalText = styled.p`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.textLightGrey};
`;
export const UploadDocs = styled.p`
  margin-left: 2%;
  cursor: pointer;
  height: 26px;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 26px;
  color: ${COLORS.darkBlue};
  flex-grow: 0;
`;
export const ContainerWrapper = styled.div`
  @media ${DEVICES.mobileXL} {
    margin-top: 48px;
  }
`;

export const DocumentsRequiredModal = styled.div`
  width: 450px;
  height: 190px;
  border-radius: 4px;
  gap: 32px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  background: white;
  font-family: ${FONT_FAMILY.hellix.regular};
  border-radius: 5px;
  padding: 2%;
  @media ${DEVICES.mobileXL} {
    width: 325px;
    height: 190px;
    padding: 4%;
  }
  @media ${DEVICES.mobileS} {
    width: 300px;
    height: 190px;
    padding: 4%;
  }
`;

export const RadioContainer = styled.div`
  .radioButtonContainer {
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 8px;
  }

  .radioButtonWrapper {
    display: flex;
    align-items: center;
  }
  .radioButtonLabel {
    position: relative;
    top: 8px;
  }
  .lightBorder {
    border: 1px solid ${COLORS.borderGrey};
    margin: 20px 10px 12px 30px;
  }

  .radioContainer {
    display: flex;
    margin-left: 30px;
    flex-direction: none !important;
  }
  .info {
    width: 80%;
    padding: 0px 10px 0px 0px;
    box-sizing: border-box;
    .inlineContent {
      display: inline-block;
      vertical-align: middle;
    }
    .orContainer {
      padding: 8px 0 16px 0;
    }
  }
  .phoneImage {
    margin-top: 1%;
    width: 20% !important;
  }

  input[type='radio'] {
    width: 24px;
    height: 24px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 50%;
    border: 2px solid ${COLORS.textLightGrey};
    outline: none;
    cursor: pointer;
    position: relative;
  }

  input[type='radio']:not(:checked) {
    border-color: ${COLORS.textLightGrey};
  }

  input[type='radio']:checked {
    border-color: ${COLORS.brandPrimary};
  }

  input[type='radio']:checked::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: ${COLORS.brandPrimary};
  }
`;

type SelectContainerProps = {
  isSelected: boolean;
};

export const SelectContainer = styled.div<SelectContainerProps>`
  background: ${(props) => (!props.isSelected ? COLORS.lightShadedGrey : COLORS.white)};
  width: 450px;
  font-size: 16px;
  line-height: 22px;
  border-radius: 8px;
  border: 1px solid ${COLORS.borderGrey};
  color: ${COLORS.textGrey};
  padding: 16px;
  margin-bottom: 16px;
  position: relative;
  .recommended-tag {
    position: absolute;
    top: 0px;
    right: 0px;
    color: ${COLORS.textGrey};
    text-align: center;
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: 11px;
    padding: 8px;
    border-radius: 5px;
    font-weight: bold;
    border-radius: 100px 8px 0px 100px;
    border: 1px solid ${COLORS.dividerBlue};
    background: ${COLORS.lightBlue};
  }

  @media ${DEVICES.mobileXL} {
    width: 100% !important;
  }
`;
export const MainContainer = styled.div`
  width: 450px;
  margin-top: 48px;
  @media ${DEVICES.mobileXL} {
    width: 90% !important;
  }
`;
export const LargeBoldText = styled.p`
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  font-style: normal;
  line-height: 26px;
`;
export const BoldText = styled.p`
  color: ${COLORS.textGrey};
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 14px;
  font-style: normal;
  line-height: 26px;
`;

export const LightText = styled.p`
  color: ${COLORS.textLightGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;
export const Error = styled.div`
  font-size: 12px;
  color: ${COLORS.red};
  margin-left: 14px;
  line-height: 20px;
`;
